// extracted by mini-css-extract-plugin
export default {"runSVG":"style-module--runSVG--41xUl"};